import { EEthereumNetworkId } from '@ankr.com/provider';
import { AbiItem } from 'web3-utils';

import { AutomateApi } from 'modules/api';
import { api, cacheTags } from 'modules/store';

export const { useGetAbiQuery, useLazyGetAbiQuery } = api.injectEndpoints({
  endpoints: build => ({
    getAbi: build.query<
      AbiItem[],
      { address: string; chainId: EEthereumNetworkId | null }
    >({
      queryFn: async ({ address, chainId }) => {
        if (!chainId) {
          throw new Error('Chain id is not defined');
        }

        const instance = new AutomateApi(chainId);

        const data = await instance.getAbi(address);

        return { data };
      },
      providesTags: [cacheTags.taskData],
    }),
  }),
});
